module.exports = __webpack_public_path__ + "static/media/PIN_BUCKLE.bd681f8d.svg";